import Vue from 'vue'
import VueMomentLib from 'vue-moment-lib'
Vue.use(VueMomentLib)
Vue.moment.locale('pt-BR')



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vuemomentlib.js